import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ElmProgressSpinnerTrackComponent } from './elm-progress-spinner-track.component';
import { ElmProgressSpinnerComponent } from './elm-progress-spinner.component';

const COMPONENTS = [
  ElmProgressSpinnerComponent,
  ElmProgressSpinnerTrackComponent
];

@NgModule({
  imports: [CommonModule, MatProgressSpinnerModule],
  exports: [COMPONENTS],
  declarations: [COMPONENTS]
})
export class ElmProgressSpinnerModule {}
